const AES_KEY_LENGTH = 32;
/**
 * Derives an AES-GCM key from `secret` with HMAC-SHA512 keyed by `key`, so each user gets their own key.
 */
export const getEncryptionKey = async (secret, key) => {
    const encoder = new TextEncoder();
    const hmacKey = await crypto.subtle.importKey('raw', encoder.encode(key), { name: 'HMAC', hash: 'SHA-512' }, false, [
        'sign',
    ]);
    const derived = await crypto.subtle.sign('HMAC', hmacKey, encoder.encode(secret));
    return crypto.subtle.importKey('raw', derived.slice(0, AES_KEY_LENGTH), 'AES-GCM', false, ['encrypt', 'decrypt']);
};
